import { render, staticRenderFns } from "./DriverList.vue?vue&type=template&id=c763b6f8&scoped=true"
import script from "./DriverList.vue?vue&type=script&lang=js"
export * from "./DriverList.vue?vue&type=script&lang=js"
import style0 from "./DriverList.vue?vue&type=style&index=0&id=c763b6f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c763b6f8",
  null
  
)

export default component.exports